import React from "react";
import { Navigate } from "react-router-dom";
import { LinearProgress } from "@material-ui/core";
import { useAuth } from "./AuthProvider";

export const ProtectedRoute = ({
  flag,
  fallback = "/dashboard",
  signInPath = "/",
  allowIfNoPermission = false,
  children,
  
}) => {
  const { loaded, user, can, access = [], isAdmin } = useAuth();
  console.log(flag, "flag in protected route1111");
  console.log(allowIfNoPermission, "allowIfNoPermission in protected route1111");
  if (!loaded) return <LinearProgress />;
  if (!user) return <Navigate to={signInPath} replace />;
  if (flag && !isAdmin && access.length === 0 && !allowIfNoPermission) {
    return <Navigate to={fallback} replace />;
  }
   if (flag && !can(flag) && !allowIfNoPermission) return <Navigate to={fallback} replace />;

  return children;
};

export default ProtectedRoute;
